export default function ({ app, $axios }) {
  $axios.defaults.baseURL = `${app.$env.NOZZLE_URL}/api/v1/`
  $axios.defaults.withCredentials = true
}
